import React, {createContext, PropsWithChildren, useMemo} from 'react';
import {DownloadInviteParams, DownloadInviteResponse, DownloadInviteService, DownloadInviteServiceImpl} from '../services';
import {ServiceResponse} from '../services/api';

export interface AccountRegistrationProviderInterface {
  sendDownloadInvite: (params: DownloadInviteParams) => Promise<ServiceResponse<DownloadInviteResponse>>;
}

export const AccountRegistrationContext = createContext<AccountRegistrationProviderInterface>(
  undefined as unknown as AccountRegistrationProviderInterface,
);

export const AccountRegistrationProvider: React.FC<PropsWithChildren> = ({children}) => {
  const downloadInviteService: DownloadInviteService = useMemo(() => new DownloadInviteServiceImpl(), []);

  const sendDownloadInvite = async (params: DownloadInviteParams): Promise<ServiceResponse<DownloadInviteResponse>> => {
    return downloadInviteService.sendDownloadInvite(params);
  };

  return <AccountRegistrationContext.Provider value={{sendDownloadInvite}}>{children}</AccountRegistrationContext.Provider>;
};
